import styled from 'styled-components';

import { CloseIcon } from '@genially/icons';

import { mixins } from '../../../style/mixins';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  maxHeight: 'inherit',
  padding: `${size.units(3)} ${size.units(3)} ${size.units(5)} ${size.units(5)}`,

  ...mixins.responsive.sm.downward({
    padding: `${size.units(2)} ${size.units(2)} ${size.units(4)} ${size.units(4)}`,
  }),
}));

export const StyledCloseIcon = styled(CloseIcon)(
  ({ theme: { color, transition, size } }) => ({
    cursor: 'pointer',
    color: color.content.secondary.default(),
    transition: transition.standard(),
    fontSize: size.units(2),

    ':hover': {
      color: color.content.secondary.hover(),
    },

    ':focus': {
      color: color.content.secondary.hover(),
    },

    ':focus-visible': {
      outline: 'auto -webkit-focus-ring-color',
    },
  }),
);

export const CloseIconWrapper = styled.div({
  display: 'flex',
  justifyContent: 'end',
  '-webkit-justify-content': 'flex-end',
});
